const formatGraphQLError = error => {
  if (!error) {
    return undefined;
  }
  const { graphQLErrors, message } = error;
  if (!(graphQLErrors && graphQLErrors.length)) {
    return error;
  }
  return {
    ...error,
    message: message.replace(/GraphQL error: /, ''),
  };
};

const round = (value, decimals = 2) =>
  Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);

const abnValidation = value => {
  if (!value || !value.match(/^[0-9]+$/) || value.length !== 11) return false;

  const abn = value.split('');

  // minus 1 from first digit
  abn[0] -= 1;

  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

  // add weight to digits
  const weighted = weights.map((weight, i) => weight * abn[i]);

  // sum of digits
  const sum = weighted.reduce((acc, weight) => acc + weight, 0);

  // get remainder
  let remainder = sum / 89;
  remainder = remainder.toString().split('.');

  // if remainder is zero number is valid
  return remainder.length === 1;
};

const isTouch = () =>
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

const slugify = (str, customRegex = '', customRegexReplace = '') => {
  if (!str || typeof str !== 'string') return '';

  return (
    !!str &&
    str
      .trim()
      .toLowerCase()
      .replace(customRegex, customRegexReplace)
      .replace(/[“”‘’]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .trim()
  );
};

export { formatGraphQLError, round, abnValidation, isTouch, slugify };
